import React, { useEffect, useRef } from 'react';
import { 
  FaHome, 
  FaBuilding, 
  FaTools, 
  FaFileAlt, 
  FaCheckCircle 
} from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const servicesRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = servicesRef.current.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: <FaHome />,
      title: 'Projetos Residenciais',
      description: 'Casas e apartamentos completos, com design personalizado e soluções inteligentes para seu lar.'
    },
    {
      icon: <FaBuilding />,
      title: 'Projetos Comerciais',
      description: 'Espaços comerciais funcionais e modernos que atendem às necessidades do seu negócio.'
    },
    {
      icon: <FaTools />,
      title: 'Projetos de Reforma',
      description: 'Renovação e modernização de espaços existentes, maximizando funcionalidade e beleza.'
    },
    {
      icon: <FaFileAlt />,
      title: 'Regularização de Imóveis',
      description: 'Documentação técnica completa para regularizar sua propriedade de acordo com as normas.'
    },
    {
      icon: <FaCheckCircle />,
      title: 'Aprovação na Prefeitura',
      description: 'Acompanhamento completo do processo de aprovação de projetos junto aos órgãos municipais.'
    }
  ];

  return (
    <section id="services" className="services section" ref={servicesRef}>
      <div className="container">
        <div className="section-header fade-in">
          <h2>Nossos Serviços</h2>
          <p>Projetos completos de construção e interiores para transformar seus sonhos em realidade!</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className={`service-card ${index % 2 === 0 ? 'slide-in-left' : 'slide-in-right'}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;